import { render, staticRenderFns } from "./ProductSetup.vue?vue&type=template&id=45aef55c&scoped=true"
import script from "./ProductSetup.vue?vue&type=script&lang=js"
export * from "./ProductSetup.vue?vue&type=script&lang=js"
import style0 from "./ProductSetup.vue?vue&type=style&index=0&id=45aef55c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aef55c",
  null
  
)

export default component.exports